import styles from './History.module.scss';

import { EntityHistory } from '@work4all/components/lib/components/entity-preview/EntityHistory';
import { mapHistoryEventEntity } from '@work4all/components/lib/components/entity-preview/erp-preview/ErpPreview';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useMaskContext } from '../../hooks/mask-context';

export type HistoryProps = {
  overrides?: {
    entity?: Entities;
  };
};

export const History = ({ overrides }: HistoryProps) => {
  const mask = useMaskContext();
  const entity = overrides?.entity ?? mask.entity;

  return (
    <div className={styles.root}>
      <EntityHistory
        entity={mapHistoryEventEntity(entity)}
        id={mask.id}
        breadcrumbTitle={mask.entity}
        fullWidth
        fullCommentEditor
        withTabs
        record={mask.data}
      />
    </div>
  );
};
